import SEO from "../ui/SEO.jsx";
import { Link } from "react-router-dom";

export default function Privacidade() {
  return (
    <div className="max-w-2xl">
      <SEO
        title="Política de Privacidade"
        description="Como tratamos seus dados no Aqui no Japão. Cookies, analytics, anúncios, direitos sob a LGPD."
        path="/privacidade"
      />

      <div className="text-[11px] tracking-[0.18em] uppercase text-accent mb-4 font-semibold">
        Política
      </div>
      <h1 className="font-serif font-medium text-4xl md:text-5xl leading-tight tracking-tight mb-6">
        Política de Privacidade
      </h1>
      <p className="text-sm text-ink-soft font-mono mb-10">
        Última atualização: maio de 2026
      </p>

      <div className="space-y-5 text-[16px] leading-[1.7] text-ink">
        <p>
          Esta política descreve como o site <strong>aquinojapao.com</strong>{" "}
          (&ldquo;nós&rdquo;, &ldquo;site&rdquo;) coleta, usa e protege
          informações dos visitantes. Escrita em linguagem direta, sem
          juridiquês desnecessário.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          1. Quais dados coletamos
        </h2>
        <p>O site usa três fontes de dados:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Dados de navegação anônimos</strong> via Google Analytics 4:
            páginas visitadas, tempo de permanência, dispositivo, navegador,
            país aproximado. <strong>Não coletamos seu nome, email ou IP
            completo</strong> (Google anonimiza o IP antes de armazenar).
          </li>
          <li>
            <strong>Cookies publicitários</strong> via Google AdSense: ao
            aceitar, o Google pode mostrar anúncios mais relevantes baseados
            nos seus interesses. Você pode desativar isso a qualquer momento
            em{" "}
            <a
              href="https://adssettings.google.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent underline"
            >
              adssettings.google.com
            </a>
            .
          </li>
          <li>
            <strong>Dados que você digita nas calculadoras</strong> (salário,
            idade, etc.) <strong>nunca saem do seu navegador</strong>. Tudo é
            calculado localmente. Não enviamos nada disso para nenhum servidor.
          </li>
        </ul>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          2. Cookies e armazenamento local
        </h2>
        <p>Usamos os seguintes tipos:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Necessários (sempre ativos):</strong> preferência de tema
            (claro/escuro), cache de cotação cambial. Esses são armazenados no
            localStorage do seu navegador e não são compartilhados com ninguém.
          </li>
          <li>
            <strong>Analíticos (com consentimento):</strong> Google Analytics
            usa cookies para identificar visitas únicas e gerar relatórios
            agregados.
          </li>
          <li>
            <strong>Publicitários (com consentimento):</strong> Google AdSense
            usa cookies para mostrar anúncios e medir performance.
          </li>
        </ul>
        <p>
          Ao visitar o site pela primeira vez, mostramos um banner pedindo seu
          consentimento. Se você recusar, apenas os cookies necessários são
          usados.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          3. Terceiros que recebem dados
        </h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Google</strong> (Analytics + AdSense): receberá dados de
            navegação se você aceitar cookies.{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent underline"
            >
              Política do Google
            </a>
            .
          </li>
          <li>
            <strong>Netlify</strong> (hospedagem): processa requisições HTTP
            comuns. Não armazena dados pessoais identificáveis dos visitantes.
          </li>
          <li>
            <strong>Frankfurter.app</strong>: API pública de câmbio. Apenas
            recebe uma requisição anônima para obter a cotação JPY → BRL.
          </li>
          <li>
            <strong>Google Fonts</strong>: hospeda as fontes do site. Pode
            registrar IP no carregamento (mesmo se você recusar cookies).
          </li>
        </ul>
        <p>
          <strong>Não vendemos nem compartilhamos dados</strong> com nenhuma
          outra empresa.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          4. Seus direitos sob a LGPD
        </h2>
        <p>
          Como brasileiro (ou qualquer visitante), você tem direito a:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Saber quais dados temos sobre você (resposta: praticamente nenhum,
            já que tudo é anônimo)
          </li>
          <li>
            Revogar consentimento a qualquer momento (apague os cookies do
            navegador ou use modo anônimo)
          </li>
          <li>Solicitar exclusão de qualquer dado pessoal</li>
          <li>Reclamar à ANPD se sentir que seus direitos não foram respeitados</li>
        </ul>
        <p>
          Para exercer qualquer um, escreva para{" "}
          <a
            href="mailto:hello@aquinojapao.com"
            className="text-accent underline"
          >
            hello@aquinojapao.com
          </a>
          .
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          5. Crianças
        </h2>
        <p>
          O site não é direcionado a menores de 13 anos. Não coletamos
          intencionalmente dados de crianças. Se você for responsável e
          souber que seu filho enviou dados pelo site, escreva para nós e
          apagamos imediatamente.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          6. Alterações
        </h2>
        <p>
          Esta política pode mudar. Quando isso acontecer, a data no topo
          desta página será atualizada. Para mudanças significativas,
          colocaremos um aviso no site.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          7. Contato
        </h2>
        <p>
          Dúvidas, sugestões, ou queixas:{" "}
          <a
            href="mailto:hello@aquinojapao.com"
            className="text-accent underline"
          >
            hello@aquinojapao.com
          </a>
          . Veja também os{" "}
          <Link to="/termos" className="text-accent underline">
            Termos de Uso
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
